export default "__VITE_ASSET__tRR6neq3__"